import styled, { css } from 'styled-components';

const StyledButton = styled.button`
  background-color: ${(props) => (`${props.active ? props.activeBackgroundColor : props.inactiveBackgroundColor} !important`)};
  border-color: ${(props) => (`${props.active ? 'transparent' : props.inactiveColor} !important`)};
  color: ${(props) => (`${props.active ? props.activeColor : props.inactiveColor} !important`)};
  min-width: 50px;
  white-space: normal;
  padding: 5px;
  border: 1px solid;
  font-size: 14px;
  flex: auto;
  margin: 5px;

  &:hover {
    border-color: transparent !important;
    background-color: ${(props) => css`${props.activeBackgroundColor} !important`};
    color: ${(props) => css`${props.activeColor} !important`};
  }

  &:focus {
    outline:none !important;
  }
`;

export default StyledButton;
